var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash-root",style:(_vm.containerSize)},[_c('router-view',{attrs:{"rem":_vm.rem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }